<template>
  <div>
    <b-alert
      v-if="!dismissible"
      v-height-fade.appear
      :variant="variant"
      :dismissible="dismissible"
      :show="show"
      class="mb-2"
    >
      <div class="alert-body">
        <feather-icon
          :icon="icon"
          class="mr-50"
        />
        {{ message }}
      </div>
    </b-alert>

    <b-alert
      v-else
      v-height-fade.appear
      :variant="variant"
      :show="dismissCountDown"
      fade
      :dismissible="dismissible"
      class="mb-2"
      @dismiss-count-down="countDownChanged"
    >
      <div class="alert-body">
        <feather-icon
          :icon="icon"
          class="mr-50"
        />
        {{ message }}
      </div>
    </b-alert>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'

export default {
  name: 'Alert',
  components: {
    BAlert,
  },
  directives: {
    'height-fade': heightFade,
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'InfoIcon',
    },
    show: {
      type: Boolean,
      required: true,
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      required: false,
      default: 'danger', // 'danger' | 'info' | 'warning' | 'success'
    },
    message: {
      type: String,
      required: true,
    },
    dismissSecs: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  data() {
    return {
      // dismissSecs: 60,
      dismissCountDown: 0,
      showDismissibleAlert: false,
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
}
</script>
